import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=f1e09178&scoped=true"
import script from "./Projects.vue?vue&type=script&lang=js"
export * from "./Projects.vue?vue&type=script&lang=js"
import style0 from "./Projects.vue?vue&type=style&index=0&id=f1e09178&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e09178",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1e09178')) {
      api.createRecord('f1e09178', component.options)
    } else {
      api.reload('f1e09178', component.options)
    }
    module.hot.accept("./Projects.vue?vue&type=template&id=f1e09178&scoped=true", function () {
      api.rerender('f1e09178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Projects/Projects.vue"
export default component.exports